import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  selector: "app-college-university-create",
  templateUrl: "./college-university-create.component.html",
  styleUrls: ["./college-university-create.component.scss"],
})
export class CollegeUniversityCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };

  @Input() record: any;        // to receive record for edit
  @Input() collegeId: string;  // to receive college id from parent

  @Output() formSaved = new EventEmitter<void>(); // notify parent on save
  @Output() cancel = new EventEmitter<void>();    // notify parent on cancel
  @Input() isPopup: boolean = false;
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  university = [];
  colleges = null;


  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private toast: ToastService,
    private sanitizer: DomSanitizer
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";


  private decodeHtml(value: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
  }
  ngOnInit() {
    this.Form = this.formBuilder.group({
      date: ["", Validators.required],
      college: ["", Validators.required],
      university: ["", Validators.required],
      description: ["", Validators.required],
      _id: [""],
    });

    // 🔹 Case 1: Popup (record passed from parent)
    if (this.record) {
      this.action = "Update";
      let formattedDate = this.record.date ? this.record.date.split('T')[0] : '';
      this.Form.patchValue({
        ...this.record,
        date: formattedDate,
        college: this.record.college || this.collegeId,
        description: this.decodeHtml(this.record.description || "")
      });
    }
    else {
      // 🔹 Case 2: Standalone route
      this.action = "Submit";
      this.Form.patchValue({ college: this.collegeId }); // ensure default

      this.ActivatedRoute.params.subscribe((params) => {
        let id = params["id"];
        if (id) {
          this.loadRecordById(id); // 🔹 fetch record if editing via route
        }
      });
    }

    // 🔹 Always load dropdown data
    this.loadColleges();
    this.loadUniversities();
  }

  private loadRecordById(id: string) {
    this.http
      .get<any>(`${environment.apiUrl}/collegeuniversitydetails/${id}`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data && data._id) {
            this.action = "Update";
            let formattedDate = data.date ? data.date.split('T')[0] : '';
            this.Form.patchValue({
              ...data,
              date: formattedDate,
            });
          }
        },
        (err: HttpErrorResponse) => {
          console.error("Error fetching record:", err);
        }
      );
  }

  private loadColleges() {
    this.http.get<any>(`${environment.apiUrl}/college/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => {
        this.colleges = data.results || data;
      },
      (err) => console.error("Error loading colleges:", err)
    );
  }

  private loadUniversities() {
    this.http.get<any>(`${environment.apiUrl}/university/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => {
        this.university = data.results || [];
      },
      (err) => console.error("Error loading universities:", err)
    );
  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        date: this.Form.value.date,
        college: this.Form.value.college,
        'university': this.Form.value.university,
        description: this.Form.value.description,

      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/collegeuniversitydetails/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(

          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              if (this.isPopup) {
                this.formSaved.emit();  // ✅ popup refresh
              } else {
                this.router.navigateByUrl("/college-details/college-university-list"); // ✅ page redirect
              }
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
            this.toast.show("Failed to save address", "error");
          }
        );
    } else {
      let data = {
        date: this.Form.value.date,
        college: this.Form.value.college,
        'university': this.Form.value.university,
        description: this.Form.value.description,
      };
      let id = this.Form.value._id;
      console.log(data);
      console.log(id);


      this.http
        .patch<any>(`${environment.apiUrl}/collegeuniversitydetails/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              if (this.isPopup) {
                this.formSaved.emit();  // ✅ popup refresh
              } else {
                this.router.navigateByUrl("/college-details/college-university-list"); // ✅ page redirect
              }
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
            this.toast.show("Failed to save address", "error");
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-university-list");
    }
  }
}
